import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// Import Components
import { CJInfoBlockLabelValueWrapper } from 'components/CustomerJourney/infoBlocks';
// Import Hooks
import { usePartnerDateFormats } from 'hooks/UsePartnerDateFormats';
// Import Services
import { Helpers } from 'services';
// Import Constants
import { l } from 'constants/common';

const { customMoment } = Helpers;

const CJDTDateInfoBlock = ({ data }) => {
    const { t } = useTranslation();
    const { partnerDateFormat } = usePartnerDateFormats();
    const { dates, months, years } = data?.value?.params ?? {};
    const date = customMoment().set('year', years).set('month', months).set('date', dates);

    return <CJInfoBlockLabelValueWrapper label={t(l.Date)} value={date.format(partnerDateFormat)} />;
};

CJDTDateInfoBlock.propTypes = {
    data: PropTypes.object.isRequired,
};

export default memo(CJDTDateInfoBlock);
